export default "__VITE_ASSET__C2OSB7uZ__"